import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { nucleoPt, nucleoEn, nucleoEs } from './nucleo';

export type Idioma = 'pt' | 'en' | 'es';
export const IDIOMAS: Idioma[] = ['pt', 'en', 'es'];

function idiomaInicial(): Idioma {
  try {
    const i = localStorage.getItem('erp.idioma');
    if (i === 'pt' || i === 'en' || i === 'es') return i;
  } catch {
    /* sem storage */
  }
  return 'pt';
}

// F8: dicionário com chaves por área (núcleo agora; cada módulo registra o seu namespace).
void i18n.use(initReactI18next).init({
  resources: { pt: { nucleo: nucleoPt }, en: { nucleo: nucleoEn }, es: { nucleo: nucleoEs } },
  lng: idiomaInicial(),
  fallbackLng: 'pt',
  defaultNS: 'nucleo',
  interpolation: { escapeValue: false },
});

export function trocarIdioma(i: Idioma): void {
  void i18n.changeLanguage(i);
  document.documentElement.lang = i === 'pt' ? 'pt-BR' : i;
  try {
    localStorage.setItem('erp.idioma', i);
  } catch {
    /* sem storage */
  }
}

/** Módulos registram seu dicionário aqui (namespace = slug do módulo). */
export function registrarDicionario(ns: string, dic: Record<Idioma, Record<string, unknown>>): void {
  for (const i of IDIOMAS) i18n.addResourceBundle(i, ns, dic[i], true, true);
}

export default i18n;
